<template lang="pug">
  router-view
</template>

<script>
export default {
  name: 'FarmSettings'
}
</script>

<style lang="scss" scoped>
</style>
